import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitDeleteInvestor } from 'components/views/FounderInvestors/_helpers/founderInvestors.events';
import { $form, $view } from 'signals/global.signals';

const FounderInvestorDeleteModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-investor-delete'}
    title="Delete Investor"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitDeleteInvestor}
    primaryButtonText="Delete"
    primaryButtonVariant="danger"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    Are you sure you want to delete <span className="text-warning fw-600">{$form.value.investorName}</span>?
  </SimpleModal>

);

export default FounderInvestorDeleteModal;
